import React, { useState } from 'react';
import axios from 'axios';
import styles from '../styles/ForgotPassword.module.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('https://crmesquita.com.br/api/forgot-password/', { email });
      setMessage(response.data.message);
    } catch (error) {
      setError('Erro ao solicitar redefinição de senha. Verifique o e-mail e tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.forgotPasswordContainer}>
      <div className={styles.forgotPasswordBox}>
        <h1 className={styles.forgotPasswordTitle}>Esqueceu a senha?</h1>
        <form onSubmit={handleSubmit} className={styles.forgotPasswordForm}>
          <div className={styles.formGroup}>
            <label htmlFor="email">Digite seu e-mail:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={styles.formInput}
            />
          </div>
          <button type="submit" className={styles.forgotPasswordButton} disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar Link'}
          </button>
        </form>
        {message && <p className={styles.successMessage}>{message}</p>}
        {error && <p className={styles.errorMessage}>{error}</p>}
      </div>
    </div>
  );
};

export default ForgotPassword;